module.exports = "/images/triangle.png?0e3de222abc6704e7821cbc5eee2564d";